import { RichText } from "./richText";

export interface IStickyNoteProperties {
  richTexts: RichText[];
  styles: any;
}

export class StickyNoteProperties implements IStickyNoteProperties {
  constructor(richTexts: RichText[]) {
    this.richTexts = [...richTexts];
  }
  richTexts: RichText[];
  styles: any;
}

export const getDefaultStickyNoteProperties = (): StickyNoteProperties => {
  return new StickyNoteProperties([new RichText("")]);
};
